import { render } from "./OrganitzacionsView.vue?vue&type=template&id=9d0b2790"
import script from "./OrganitzacionsView.vue?vue&type=script&lang=js"
export * from "./OrganitzacionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__